import { Queue } from '@cian/event-queue';

import { type TEvents } from '../../types/events';

export function getEventQueue(): Queue<TEvents> {
  if (typeof window !== 'undefined') {
    return window.eventQueue || (window.eventQueue = new Queue<TEvents>());
  }

  return new Queue<TEvents>();
}
